module.exports = __webpack_public_path__ + "static/media/cafe_nordoy.3afa804a.jpg";